import constants from '@/config/constant';
import {
  BaseQueryApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryArgs,
} from '@reduxjs/toolkit/query/react';
import {signFetchArgs} from '@/auth/request-signing';

// We can also pass in the configurations (such as header configurations) through the arguments
// while calling from api-slices
export const fetchBaseQueryWrapper = (args?: FetchBaseQueryArgs) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: constants.API_BASE_URL,
    prepareHeaders,
    ...args,
  });
  return async (
    args: string | FetchArgs,
    api: BaseQueryApi,
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    extraOptions: {},
  ) => {
    // In direct-auth mode, sign the request in-browser before it goes out.
    // No-op when the feature flag is off. A locked session surfaces as the
    // CUSTOM_ERROR shape the UI already handles.
    let signedArgs: string | FetchArgs;
    try {
      signedArgs = await signFetchArgs(args);
    } catch (err) {
      return {
        error: {
          status: 'CUSTOM_ERROR' as const,
          error: err instanceof Error ? err.message : 'Direct-auth session is locked',
        },
      };
    }

    const result = await baseQuery(signedArgs, api, extraOptions);
    if (result.error) {
      switch (result.error.status) {
        case 401:
          break;
        case 404:
          break;
        default:
          break;
      }
    }

    return result;
  };
};

const prepareHeaders: FetchBaseQueryArgs['prepareHeaders'] = async (
  headers,
) => {
  return headers
};

